export default "__VITE_ASSET__BMec5LM$__"